import React, { Component, Fragment } from "react";
import { Link, withRouter } from 'react-router-dom'
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import FabGuide from '../../components/molecule/Guides/FabGuide';
import { setGlobalLoadingSpinner } from '../../modules/GlobalUI';
import LoadingOverlay from '../../components/molecule/LoadingOverlay';
import KeyboardReturn from '@material-ui/icons/KeyboardReturn';

import ListItemLink from './sideBar';
import { topLinks } from './paths';
import Main from "./main";

const STRIVERS_LOGO = require('../../assets/strivers_logo_white.png').default;

const drawerWidth = 240;

const styles = theme => ({
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  textContainer: {
    paddingRight: 24, // keep right padding when drawer closed
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: 1,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    backgroundColor: '#1e1f20',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarAuth: {
    width: `calc(100% - 72px)`,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  barList: {
    display: 'flex',
    flex: 1,
  },
  // titleShow: {
  //   opacity: 1,
  //   transition: theme.transitions.create(['opacity'], {
  //     easing: theme.transitions.easing.sharp,
  //     duration: theme.transitions.duration.enteringScreen,
  //   }),
  // },
  menuButton: {
    margin: 'auto',
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 0,
  },
  subtitle: {
    flexGrow: 0,
    fontSize: '0.9rem',
    lineHeight: 1,
  },
  titleBar: {
    opacity: 0,
    flexGrow: 1,
    textAlign: 'center',
    // position: 'absolute',
    transition: theme.transitions.create(['opacity'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  titleShow: {
    opacity: 1,
  },
  bottomSection: {
    marginTop: 'auto',
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth, 
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
});

class Layout extends Component {
  state = {
    open: true,
  };

  handleDrawerClick = () => {
    this.setState({ open: !this.state.open });
  };

  getSelected = items => {
    const { location } = this.props;
    let pageInfo = { text: 'Strivers', guide: null };

    for(let i = 0; i < items.length; i++) {
      const item = items[i];
      if(location.pathname.match(item.reg)) {
        pageInfo.text = item.header;

        if(item.subDirects) {
          for(let j = 0; j < item.subDirects.length; j++) {
            const sub = item.subDirects[j];
            if(location.pathname.match(sub.reg)) {
              if (sub.header) {
                pageInfo.text = sub.header;
              }
              if (sub.title) {
                document.title = item.title;
              }
              pageInfo.guide = sub.guide;
              return pageInfo;
            }
          }
        }

        document.title = item.title;

        pageInfo.guide = item.guide;
        return pageInfo;
      }
    }

    return pageInfo;
  }

  makeLinks = () => {
    const { authState, location } = this.props;
    const { is_staff, is_superuser, trainer_relationship } = authState && authState.userData ? authState.userData : {};
    const individualCoachPath = "/digital-coaching/individual-coaching/";
    return (
      topLinks.filter(item => { 
        if ((item.roles.indexOf('staff') >= 0 && is_staff) ||
          (item.roles.indexOf('admin') >= 0 && is_superuser) ||
          (trainer_relationship && item.roles.indexOf(trainer_relationship) >= 0)) {
          return true
        } else {
          return false
        }
      }).map((item, itemIndex) => {
        if (!is_superuser && item.to === "/digital-coaching") {
          item.to = individualCoachPath;
        }
        return (
          <ListItemLink key={`links-key-${itemIndex}`} to={item.to} selected={location.pathname.includes(item.to)} primary={item.text} icon={item.icon} />
        )
      }
      )
    )
  }

  sideBarTabs = () => {
    const { classes } = this.props;
    return (
      <div className={classes.listContainer}>
        {this.makeLinks()}
        <div className={classes.bottomSection}>
          <li>
            <ListItem button component={Link} to="/logout">
              <ListItemIcon>
                <KeyboardReturn/>
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </li>
        </div>
      </div>
    )
  };

  render() {
    const {
      authState: { accessDenied, isAuthenticated, isAuthenticating },
      classes,
      location,
    } = this.props;

    const { guide } = this.getSelected(topLinks);

    const iconButton = (
      <IconButton
        color="inherit"
        aria-label="Open drawer"
        onClick={this.handleDrawerClick}
        className={classNames(classes.menuButton)}
      >
        <MenuIcon />
      </IconButton>
    );

    const drawer = (
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
        }}
        open={this.state.open}
      >
        <div className={classes.toolbarIcon}>
          {iconButton}
          <img src={STRIVERS_LOGO} alt="Strivers" />
        </div>
        <Divider />
        <List className={classes.barList}>
          {this.sideBarTabs()}
        </List>
      </Drawer>
    );

    return (
      <Fragment>
        <AppBar position="absolute"
          className={classNames(classes.appBar)} /*, (isAuthenticated) && classes.appBarAuth, (this.state.open && isAuthenticated) && classes.appBarShift)}*/
        >
          <Toolbar className={classes.toolbar}>
            {isAuthenticated && iconButton}
            <div className={classes.textContainer}>
              <img src={STRIVERS_LOGO} alt="Strivers" />
            </div>
          </Toolbar>
        </AppBar>
        {isAuthenticated && drawer}
        <Main accessDenied={accessDenied} isAuthenticated={isAuthenticated} isAuthenticating={isAuthenticating} />
        {
          guide &&
          <FabGuide
            key={`guide-${location.pathname}`}
            actions={guide}
          />
        }
        <LoadingOverlay/>
      </Fragment>
    );
  }
}


function mapStateToProps(state) {
  return {
    authState: state.authState,
    globalUIState: state.globalUIState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setGlobalLoadingSpinner: setGlobalLoadingSpinner,
  }, dispatch)
}


export default compose(withRouter, withCookies, withStyles(styles), connect(mapStateToProps,mapDispatchToProps))(Layout);
